<template>
  <a
    v-bind="$attrs"
    :class="classes"
    :href="finalHref"
    @click="$emit('click', $event)"
  ><slot /></a>
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    underline: Boolean,
    color: {
      type: String,
      default: undefined,
      validator(value) {
        return ['black', 'darkBlue', 'gray', 'ai-red'].includes(value);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: undefined
    }
  },
  emits: ['click'],
  computed: {
    classes() {
      return [
        this.$style.link,
        this.$style[this.color],
        {
          [this.$style.underline]: this.underline,
          [this.$style.disabled]: this.disabled
        }
      ];
    },
    finalHref() {
      if (this.disabled) {
        return undefined;
      }
      return this.href;
    }
  }
};
</script>

<style module>
.link {
  text-decoration: none;
  color: #2cc8df;
  cursor: pointer;
  &:hover {
    color: $linkHoverColor;
  }
}
.underline {
  text-decoration: underline;
}
.black {
  color: $textColor;
}
.darkBlue {
  color: #50808a;
}
.disabled,
.gray {
  color: #bbbbbb;
}
.ai-red {
  color: $aiColor;
}

.disabled {
  cursor: not-allowed;
}
</style>

<i18n lang="json">{}</i18n>
